import React, { useState } from "react";
import { Alert } from "@material-ui/lab";
import CloseIcon from "@material-ui/icons/Close";
import { CircularProgress } from "@material-ui/core";

export const UploadPreview = ({
    error,
    files,
    editMode,
    maxFiles,
    previewFiles,
    getInputProps,
    getRootProps,
    handleUpload,
    handleDelete,
    handleCancel,
    handleError,
    handleCloseError
}) => {
    const [isLoading, setIsLoading] = useState(false);

    return (
        <div className="upload_preview_container">
            <label>
                <div className="thumbs_container" {...!isLoading && getRootProps()}>
                    {!isLoading && <input id="fileInput" {...getInputProps()} />}
                    {previewFiles.map(file => {
                        return (
                            <div className="thumb" key={file.id} onClick={e => e.stopPropagation()}>
                                <div className="thumb_inner thumb_relative">
                                    <img src={file.imageUrl} className="thumb_img" alt={"img"} />
                                    <button className="thumb_delete_button" disabled={isLoading} onClick={(e) => {
                                        e.preventDefault();
                                        if (editMode && previewFiles.length === 1) {
                                            handleError("minFileRequired");
                                        } else {
                                            handleDelete(file.id);
                                        }
                                    }}>
                                        <CloseIcon fontSize="small" style={{ cursor: "pointer" }} />
                                    </button>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </label>
            {error.errorStatus && (
                <Alert severity="warning" style={{ marginTop: "5px" }} onClose={() => handleCloseError()}>
                    {error.errorMessage}
                </Alert>
            )}
            <div className="upload_actions">
                <button
                    className="upload_action_button highlighted_button"
                    disabled={error.errorStatus || isLoading}
                    style={{ ...((error.errorStatus || isLoading) && { opacity: 0.5 }) }}
                    onClick={async e => {
                        e.preventDefault();
                        if (editMode && previewFiles.length === 1) {
                            setIsLoading(true);
                            await handleUpload(previewFiles);
                        } else if (previewFiles.length + files.length <= maxFiles && !editMode) {
                            setIsLoading(true);
                            await handleUpload(previewFiles);
                        } else {
                            return handleError(editMode ? "maxFileEdit" : "maxFile");
                        }
                    }}>
                    {isLoading && <CircularProgress color="success" style={{ height: "15px", width: "15px", marginRight: '5px' }} />}
                    Upload
                </button>
                <button className="upload_action_button"
                    disabled={error.errorStatus || isLoading}
                    style={{ ...((error.errorStatus || isLoading) && { opacity: 0.2 }) }}
                    onClick={() => handleCancel()}>
                    Cancel
                </button>
            </div>
        </div>
    );
};
